var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('legend', [_vm._v("\n                Reprint Pendency (" + _vm._s(this.totalPrintreprintPendencyList ?
    this.totalPrintreprintPendencyList.length : 0) + ") "), _c('i', {
    staticClass: "fa fa-download pull-right",
    staticStyle: {
      "margin-top": "6px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.exportToCSV
    }
  })]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "tabs-active",
    staticStyle: {
      "box-shadow": "1px solid #494949"
    }
  }, [_c('div', [_c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Flyer Id")]), _vm._v(" "), _c('th', [_vm._v("Last Printed By")]), _vm._v(" "), _c('th', [_vm._v("Pending Since")])])]), _vm._v(" "), _c('tbody', [(_vm.reprintPendencyList.length > 0) ? _vm._l((_vm.reprintPendencyList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.flyerbarcode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.requestedby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.requesteddate))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5be6662","hasScoped":true}!./src/views/components/RVPPrintPendency/RVPPrintPendency.component.html
// module id = 1588
// module chunks = 1